import type { LabelArgs } from '@customTypes/labels';
import type { PageOptionType } from '@customTypes/productOptions';
import type { IGatsbyImageData } from 'gatsby-plugin-image';
import { useStaticQuery, graphql } from 'gatsby';

type RecommendationProductType = {
  title: string;
  subtitle: string;
  description: string;
  rank: number;
  realPrice: number;
  salePrice: number;
  labels: LabelArgs;
  url: string;
  image?: {
    localFile: {
      publicURL: string;
      childImageSharp?: IGatsbyImageData;
    };
  };
  video?: {
    localFile: {
      publicURL: string;
    };
  };
  gallery?: {
    id: string;
    localFile: {
      publicURL: string;
      full: { gatsbyImageData: IGatsbyImageData };
      preview: { gatsbyImageData: IGatsbyImageData };
    };
  }[];
  options: {
    pageOptions?: PageOptionType[];
  };
};

export type RecommendationItemType = {
  title: string;
  key: string;
  id: string;
  products: RecommendationProductType[];
};

export const useRecommendations = () => {
  const {
    allStrapiRecommendation: { nodes },
  } = useStaticQuery(graphql`
    {
      allStrapiRecommendation {
        nodes {
          title
          key
          id
          products {
            title
            subtitle
            url
            labels {
              id
              name
              text
              color
              backgroundColor
            }
            options {
              ... on STRAPI__COMPONENT_PRODUCT_COMPONENTS_PAGE_OPTION {
                id
                price
                optionSalePrice
                value
                actionUrl
              }
            }
            video {
              localFile {
                publicURL
              }
            }
            gallery {
              id
              localFile {
                publicURL
                full: childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
                preview: childImageSharp {
                  gatsbyImageData(
                    aspectRatio: 1
                    width: 320
                    outputPixelDensities: [1, 2]
                    transformOptions: { cropFocus: CENTER }
                  )
                }
              }
            }
            image {
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    aspectRatio: 1
                    width: 320
                    outputPixelDensities: [1, 2]
                    transformOptions: { cropFocus: CENTER }
                  )
                }
              }
            }
          }
        }
      }
    }
  `);

  return nodes || [];
};
